import React, { useContext } from "react";
import classes from "./Slider.module.scss";
import { ThemeContext } from "../../../store/theme-context";

const Slider = () => {
  const { theme, toggleTheme } = useContext(ThemeContext);

  return (
<label className={classes.switch}>
  <input
    type="checkbox"
    checked={theme === "_dark"}
    onChange={() => toggleTheme()}
  />
 <span
  className={`${classes.slider} ${classes.round} theme-slider`}
/>

</label>

  );
};

export default Slider;
